import React from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";

/**
 * Standard surface used across the Credit Checker: a bordered card with an
 * optional icon, title, subtitle and a right-aligned action slot.
 *
 * When `collapsible` is set the header acts as a toggle (chevron on the right)
 * and the body shows/hides; `defaultCollapsed` controls the initial state.
 */
class CardBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = { collapsed: Boolean(props.defaultCollapsed) };
    }

    toggle = () =>
        this.setState(prev => ({ collapsed: !prev.collapsed }));

    render() {
        const {
            icon,
            title,
            subtitle,
            action,
            className,
            children,
            collapsible
        } = this.props;
        const collapsed = collapsible && this.state.collapsed;
        return (
            <div className={"cc-card" + (className ? " " + className : "")}>
                {title || action ? (
                    <div
                        className={"cc-card__head"}
                        onClick={collapsible ? this.toggle : undefined}
                        style={collapsible ? { cursor: "pointer" } : undefined}
                    >
                        <div className={"cc-card__head-left"}>
                            {icon ? (
                                <span className={"cc-card__icon"}>
                                    <Icon type={icon} />
                                </span>
                            ) : null}
                            <div>
                                {title ? (
                                    <div className={"cc-card__title"}>
                                        {title}
                                    </div>
                                ) : null}
                                {/* Card subtitles suppressed per credit-team
                                    request — one-line card headers only.
                                    Prop still accepted for back-compat but
                                    never rendered. */}
                            </div>
                        </div>
                        <div className={"cc-card__action"}>
                            {action}
                            {collapsible ? (
                                <Icon
                                    type={collapsed ? "down" : "up"}
                                    style={{ marginLeft: 8, color: "#8a93a3" }}
                                />
                            ) : null}
                        </div>
                    </div>
                ) : null}
                {collapsed ? null : (
                    <div className={"cc-card__body"}>{children}</div>
                )}
            </div>
        );
    }
}

CardBlock.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    action: PropTypes.node,
    className: PropTypes.string,
    children: PropTypes.node,
    collapsible: PropTypes.bool,
    defaultCollapsed: PropTypes.bool
};

export default CardBlock;
